import { AccountObject, IAccountObjectArgs } from "../account-object/account-object.model";

export interface IJobDataArgs extends IAccountObjectArgs {
    job: string;
}

const defaults = {
    job: ""
} as IJobDataArgs;

export class JobData extends AccountObject {
    job: string;

    constructor(data?: IJobDataArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-data/job-data.model.ts